module.exports = __webpack_public_path__ + "aws.icon.a1be6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/logo/aws.icon.svg
// module id = 3512
// module chunks = 0